export enum ProspectType {
  Account = 'account',
  Contact = 'contact',
}
